import { useField, useFormState } from 'react-final-form';

export const useHasPromotionApplied = (fieldName: string) => {
  const { input: bonusCashInput } = useField(`${fieldName}.bonusCash`, {
    subscription: { value: true }
  });

  const { input: freeBetInput } = useField(`${fieldName}.freeBet`, {
    subscription: { value: true }
  });

  const { values } = useFormState({ subscription: { values: true } });

  const hasAnyPromotionApplied = Object.entries(values).some(
    ([_key, { bonusCash, freeBet }]) => bonusCash?.length || freeBet?.length
  );

  const hasFreeBetApplied = Boolean(freeBetInput.value?.length);
  const hasBonusCashApplied = Boolean(bonusCashInput.value?.length);
  const hasPromotionApplied = hasFreeBetApplied || hasBonusCashApplied;
  return {
    hasFreeBetApplied,
    hasBonusCashApplied,
    hasPromotionApplied,
    hasOtherPromotionApplied: !hasPromotionApplied && hasAnyPromotionApplied
  };
};
